/* ==========================================================================
   CANDELINAS CUSTOM — ARCHIVE II drop controller

   Differs from the prototype in two important ways:
   1. The grid is SERVER-RENDERED by Liquid (§5 "server-rendered on load, do
      not poll"). This file never builds cards — it only reads the steppers,
      drives the bar/ladder, and talks to the cart. That keeps stock truthful
      and avoids layout shift.
   2. Selection is held locally and pushed to the cart in ONE /cart/add.js on
      CTA. Native automatic discounts then apply at cart/checkout. Stepping
      each click straight into the cart would be slow and chatty.

   Config + every user-facing string is injected from Liquid via
   window.ARCHIVE_II so nothing here needs translating (§7).
   ========================================================================== */
(function () {
  'use strict';

  var CFG = window.ARCHIVE_II;
  if (!CFG) return;

  // Fallback for browsers without :has() — lets the CSS make <main> opaque so
  // Stiletto's fixed footer can't show through the page.
  if (document.querySelector('.aii')) document.documentElement.classList.add('aii-page');

  var T = CFG.tiers || [];
  var RRP = CFG.rrp || 8;
  var VIP_PCT = CFG.vipDiscount || 0;
  var MODE = CFG.mode || 'tiers';
  var MAX = CFG.maxPerScent || 10;
  // Greek market only. Elsewhere Markets marks every price up and the tier
  // euros in the theme settings stop matching the cart, so the bar drops the
  // totals and quotes the discount percentage, which is market-independent.
  var SHOW_MONEY = CFG.showMoney !== false;
  var S = CFG.strings || {};
  var UNLOCK_KEY = 'archive-ii-unlocked';

  // Each ARCHIVE II block is its own Shopify section, so they are siblings —
  // there is no single wrapper element to scope queries to. Bind at document
  // level and let the data- attributes do the selecting.
  var root = document;

  /* ── money ──────────────────────────────────────────────────────────── */
  // Decimal comma, and no trailing ",00" on whole euros (§7): €24 / €7,20
  function eur(v) {
    var n = Math.round(v * 100) / 100;
    return '€' + (n % 1 ? n.toFixed(2).replace('.', ',') : String(n));
  }

  /* ── ladder math (mirrors the three native discounts in §1) ─────────── */
  // B1G1 is a TOTAL rule (every second bar free), not a per-unit rate, so it
  // cannot be expressed as a tier: at odd quantities ceil(n/2)*RRP and
  // n*(flat rate) disagree. price() owns the maths and rate() derives the
  // "€X ΤΟ ΕΝΑ" line from it — computed inline, never by calling price(),
  // or the two would recurse.
  function b1g1() { return MODE === 'b1g1' && !vipWindow(); }

  function rate(n) {
    // During the VIP window every bar is marked down by a flat percentage and
    // the tier discounts are not running yet. Quoting a tier rate here would
    // show a total the cart will never charge.
    if (vipWindow()) return RRP * (100 - VIP_PCT) / 100;
    if (b1g1()) return n ? Math.ceil(n / 2) * RRP / n : RRP;
    for (var i = T.length - 1; i >= 0; i--) if (n >= T[i].q) return T[i].p / T[i].q;
    return RRP;
  }
  // Discount reached at n bars, derived from the same tier table as the euros.
  function tierPct(n) {
    for (var i = T.length - 1; i >= 0; i--) {
      if (n >= T[i].q) return Math.round(100 - (T[i].p * 100 / (T[i].q * RRP)));
    }
    return 0;
  }

  function price(n) {
    if (!n) return 0;
    if (b1g1()) return Math.ceil(n / 2) * RRP;
    return Math.round(n * rate(n) * 100) / 100;
  }

  // Next rung up, or null once the top rung is reached.
  function nextStep(n) {
    // No rung to chase while the flat markdown is on.
    if (vipWindow()) return null;
    // Odd basket ⇒ the next bar costs nothing. This is the whole point of the
    // mechanic: it makes rounding up feel free, which is what moves units.
    if (b1g1()) return (n % 2) ? { b1g1Free: true, add: 1 } : null;
    for (var i = 0; i < T.length; i++) {
      if (n < T[i].q) return { add: T[i].q - n, diff: price(n) - T[i].p, to: T[i].q, p: T[i].p };
    }
    return null;
  }

  function fmt(str, map) {
    return String(str || '').replace(/\{(\w+)\}/g, function (m, k) {
      return map[k] !== undefined ? map[k] : m;
    });
  }

  /* ── phase ──────────────────────────────────────────────────────────── */
  var phase = CFG.phase || 'tease';

  function isUnlocked() {
    if (phase === 'live') return true;
    try { if (localStorage.getItem(UNLOCK_KEY) === 'true') return true; } catch (e) {}
    if (CFG.vipEnd) {
      var end = Date.parse(CFG.vipEnd);
      if (!isNaN(end) && Date.now() >= end) return true;
    }
    return false;
  }
  function buying() { return phase === 'live' || (phase === 'gate' && isUnlocked()); }

  // True only while the VIP early-access window is genuinely open: the gate
  // phase is set AND vip_end has not passed. It flips itself to false at
  // vip_end, so the tiers come back on their own even before the phase
  // setting is switched to Live by hand.
  function vipWindow() {
    if (phase !== 'gate') return false;
    if (!CFG.vipEnd) return true;
    var end = Date.parse(CFG.vipEnd);
    return isNaN(end) ? true : Date.now() < end;
  }

  /* ── selection ──────────────────────────────────────────────────────── */
  // { variantId: qty }. Seeded from the live cart so the nudge counts bars
  // the customer already added on a previous visit.
  var box = {};

  function total() {
    var n = 0;
    for (var k in box) if (Object.prototype.hasOwnProperty.call(box, k)) n += box[k];
    return n;
  }

  function stepperFor(id) { return root.querySelector('[data-aii-step="' + id + '"]'); }

  function paintStepper(id) {
    var el = stepperFor(id);
    if (!el) return;
    var q = box[id] || 0;
    var stock = parseInt(el.getAttribute('data-aii-stock'), 10) || 0;
    var cap = Math.min(stock, MAX);
    var out = el.querySelector('[data-aii-qty]');
    var minus = el.querySelector('[data-aii-minus]');
    var plus = el.querySelector('[data-aii-plus]');
    if (out) out.textContent = q;
    if (minus) minus.disabled = q <= 0;
    if (plus) plus.disabled = q >= cap;
    var card = el.closest('[data-aii-card]');
    if (card) card.classList.toggle('is-pick', q > 0);
  }

  function paintAllSteppers() {
    var all = root.querySelectorAll('[data-aii-step]');
    for (var i = 0; i < all.length; i++) paintStepper(all[i].getAttribute('data-aii-step'));
  }

  /* ── ladder highlight ───────────────────────────────────────────────── */
  function paintRungs() {
    var n = buying() ? total() : 0;
    var rungs = document.querySelectorAll('[data-aii-rung]');
    for (var i = 0; i < rungs.length; i++) {
      var q = parseInt(rungs[i].getAttribute('data-aii-rung'), 10);
      var nextQ = i + 1 < rungs.length ? parseInt(rungs[i + 1].getAttribute('data-aii-rung'), 10) : Infinity;
      rungs[i].classList.toggle('is-on', n >= q && n < nextQ);
    }
  }

  /* ── bottom bar ─────────────────────────────────────────────────────── */
  var bar = document.querySelector('[data-aii-bar]');

  function paintBar() {
    paintRungs();
    if (!bar) return;

    // Tease: the bar reflects the wishlist, not a cart.
    if (phase === 'tease') { bar.classList.remove('is-show'); document.body.classList.remove('aii-has-bar'); return; }
    if (!buying()) { bar.classList.remove('is-show'); document.body.classList.remove('aii-has-bar'); return; }

    var n = total();
    var p = price(n);
    var show = n > 0;
    bar.classList.toggle('is-show', show);
    document.body.classList.toggle('aii-has-bar', show);

    var set = function (sel, val) { var el = bar.querySelector(sel); if (el) el.textContent = val; };
    set('[data-aii-count]', n);
    if (SHOW_MONEY) {
      set('[data-aii-price]', n ? eur(p) : '');
      set('[data-aii-each]', n ? fmt(S.each, { rate: eur(p / n) }) : '');
    } else {
      var pctNow = tierPct(n);
      set('[data-aii-price]', '');
      set('[data-aii-each]', n && pctNow ? fmt(S.pctNow, { pct: pctNow }) : '');
    }

    var nudge = bar.querySelector('[data-aii-nudge]');
    var prog = bar.querySelector('[data-aii-prog]');
    var s = nextStep(n);

    if (vipWindow()) {
      // Flat markdown: state the offer instead of nudging toward a tier that
      // is switched off.
      nudge.textContent = n ? fmt(S.vip, { pct: VIP_PCT }) : '';
      if (prog) prog.style.width = n ? '100%' : '0%';
    } else if (b1g1()) {
      // Odd basket ⇒ push the free one. Even ⇒ the offer is already working,
      // so say that; falling through to boxFull would claim something else.
      nudge.textContent = n ? ((s && s.b1g1Free) ? S.b1g1Free : S.b1g1On) : '';
      if (prog) prog.style.width = n ? (n % 2 ? '50%' : '100%') : '0%';
    } else if (s && n) {
      // The €24 case at 9 bars is the most valuable string on the page (§6).
      if (SHOW_MONEY) {
        nudge.textContent = s.diff > 0
          ? fmt(S.nudgeSave, { n: s.add, diff: eur(s.diff) })
          : fmt(S.nudgeRate, { n: s.add, rate: eur(s.p / s.to) });
      } else {
        nudge.textContent = fmt(S.nudgePct, { n: s.add, pct: Math.round(100 - (s.p * 100 / (s.to * RRP))) });
      }
      var prev = 0;
      for (var i = 0; i < T.length; i++) if (T[i].q <= n) prev = T[i].q;
      if (prog) prog.style.width = ((n - prev) / (s.to - prev) * 100) + '%';
    } else {
      nudge.textContent = n ? S.boxFull : '';
      if (prog) prog.style.width = n ? '100%' : '0%';
    }

    var cta = bar.querySelector('[data-aii-cta]');
    if (cta) cta.disabled = !n;
  }

  /* ── stepper events ─────────────────────────────────────────────────── */
  root.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-aii-plus],[data-aii-minus]');
    if (!btn || btn.disabled) return;
    var wrap = btn.closest('[data-aii-step]');
    if (!wrap) return;
    var id = wrap.getAttribute('data-aii-step');
    var stock = parseInt(wrap.getAttribute('data-aii-stock'), 10) || 0;
    var cap = Math.min(stock, MAX);
    var cur = box[id] || 0;
    var next = cur + (btn.hasAttribute('data-aii-plus') ? 1 : -1);
    next = Math.max(0, Math.min(next, cap));
    if (next) box[id] = next; else delete box[id];
    paintStepper(id);
    paintBar();
  });

  /* ── add to cart ────────────────────────────────────────────────────── */
  function addToCart() {
    var items = [];
    for (var id in box) if (box[id] > 0) items.push({ id: Number(id), quantity: box[id] });
    if (!items.length) return;

    var cta = bar && bar.querySelector('[data-aii-cta]');
    if (cta) { cta.disabled = true; cta.setAttribute('data-busy', '1'); }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        box = {};
        paintAllSteppers();
        paintBar();
        // Hand off to the theme's drawer, same events the rest of the site uses.
        document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('apps:product-added-to-cart', { bubbles: true }));
      })
      .catch(function () {
        if (cta) cta.textContent = S.addError || S.cta;
      })
      .finally(function () {
        if (cta) { cta.removeAttribute('data-busy'); cta.disabled = !total(); }
      });
  }

  if (bar) {
    var ctaBtn = bar.querySelector('[data-aii-cta]');
    if (ctaBtn) ctaBtn.addEventListener('click', addToCart);
  }

  /* ── bundle card ────────────────────────────────────────────────────── */
  // The bundle is a single fixed-price product, deliberately outside the box:
  // it never touches `box`, the steppers or the tier maths, so a €72 line can
  // never be counted as a "bar". Everything else is identical to addToCart —
  // same endpoint, same two events — so the drawer behaves exactly as it does
  // everywhere else on the site.
  var bundleBtn = document.querySelector('[data-aii-bundle-add]');
  if (bundleBtn) {
    bundleBtn.addEventListener('click', function () {
      var vid = Number(bundleBtn.getAttribute('data-aii-variant'));
      if (!vid || bundleBtn.disabled) return;
      var label = bundleBtn.textContent;
      bundleBtn.disabled = true;
      bundleBtn.setAttribute('data-busy', '1');

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: vid, quantity: 1 }] })
      })
        .then(function (r) { return r.json(); })
        .then(function () {
          document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true }));
          document.dispatchEvent(new CustomEvent('apps:product-added-to-cart', { bubbles: true }));
        })
        .catch(function () { bundleBtn.textContent = S.addError || label; })
        .finally(function () {
          bundleBtn.removeAttribute('data-busy');
          bundleBtn.disabled = false;
        });
    });
  }

  /* ── seed from the existing cart ────────────────────────────────────── */
  function seedFromCart() {
    if (!buying()) { paintBar(); return; }
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        (cart.items || []).forEach(function (item) {
          var el = stepperFor(String(item.variant_id));
          if (!el) return;
          var stock = parseInt(el.getAttribute('data-aii-stock'), 10) || 0;
          box[String(item.variant_id)] = Math.min(item.quantity, Math.min(stock, MAX));
        });
        paintAllSteppers();
        paintBar();
      })
      .catch(function () { paintBar(); });
  }

  /* ── gate ───────────────────────────────────────────────────────────── */
  function openUp() {
    try { localStorage.setItem(UNLOCK_KEY, 'true'); } catch (e) {}
    var gate = document.querySelector('[data-aii-gate]');
    if (gate) gate.classList.add('aii-hide');
    var inVip = vipWindow();
    var locked = document.querySelectorAll('[data-aii-locked]');
    for (var i = 0; i < locked.length; i++) {
      // The ladder stays hidden for the whole VIP window. Entering the code
      // must not reveal a discount structure that only starts at vip_end.
      if (inVip && locked[i].hasAttribute('data-aii-ladder-wrap')) continue;
      locked[i].classList.remove('aii-hide');
    }
    seedFromCart();
    // "The page opening up, not a redirect" (§3). During VIP the ladder is
    // still hidden, so open onto the grid instead of scrolling to nothing.
    var anchor = inVip ? document.getElementById('aii-grid') : null;
    if (!anchor) anchor = document.querySelector('[data-aii-ladder]');
    if (anchor) anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // Greek keyboards produce characters that LOOK identical to Latin ones but
  // are different code points (Α≠A, Ρ≠P, Η≠H, Ι≠I, Ε≠E, Χ≠X …). A VIP with the
  // Greek layout on would type what looks exactly like the code and be told it
  // is wrong. Fold those to Latin before comparing, and drop anything that
  // isn't alphanumeric so stray spaces or a trailing dash can't fail it either.
  var GREEK_TO_LATIN = {
    'Α':'A','Β':'B','Ε':'E','Ζ':'Z','Η':'H','Ι':'I','Κ':'K','Μ':'M','Ν':'N',
    'Ο':'O','Ρ':'P','Τ':'T','Υ':'Y','Χ':'X','Ϝ':'F','Θ':'O','Σ':'S'
  };
  function normalizeCode(s) {
    return String(s || '')
      .trim()
      .toUpperCase()
      .replace(/[ΑΒΕΖΗΙΚΜΝΟΡΤΥΧϜΘΣ]/g, function (ch) { return GREEK_TO_LATIN[ch] || ch; })
      .replace(/[^A-Z0-9]/g, '');
  }

  var gateForm = document.querySelector('[data-aii-gate-form]');
  if (gateForm) {
    var input = gateForm.querySelector('[data-aii-code]');
    var err = document.querySelector('[data-aii-gate-error]');
    var submit = function (e) {
      if (e) e.preventDefault();
      var val = normalizeCode(input.value);
      var want = normalizeCode(CFG.vipCode);
      if (val && want && val === want) { if (err) err.textContent = ''; openUp(); }
      else if (err) err.textContent = S.gateError;
    };
    gateForm.addEventListener('submit', submit);
    var goBtn = gateForm.querySelector('[data-aii-gate-go]');
    if (goBtn) goBtn.addEventListener('click', submit);
  }

  // At vip_end, open for everyone already sitting on the page — no refresh (§3).
  if (phase === 'gate' && CFG.vipEnd) {
    var endAt = Date.parse(CFG.vipEnd);
    if (!isNaN(endAt)) {
      var wait = endAt - Date.now();
      if (wait > 0 && wait < 86400000) {
        setTimeout(function () {
          document.dispatchEvent(new CustomEvent('archive:vip-ended', { bubbles: true }));
          // vipWindow() reads false from here, so this reveals the ladder and
          // repaints every total at tier pricing.
          openUp();
          paintBar();
        }, wait);
      }
    }
  }

  /* ── wishlist relabel (tease) ───────────────────────────────────────── */
  // SE Wishlist Engine injects its own button; §2 says relabel it rather than
  // building a second wishlist. It renders async, so watch for it.
  if (phase === 'tease' && S.wishlistAdd) {
    var relabel = function () {
      var hosts = root.querySelectorAll('.aii-wl-host');
      for (var i = 0; i < hosts.length; i++) {
        var b = hosts[i].querySelector('.wishlist-engine-button, button');
        if (!b) continue;
        var added = hosts[i].querySelector('[data-added="true"]') || hosts[i].getAttribute('data-added') === 'true';
        var want = added ? S.wishlistAdded : S.wishlistAdd;
        if (b.textContent.trim() !== want) b.textContent = want;

        // The app injects a <div>, not a <button>, so during tease the only
        // call to action on the page is unreachable by keyboard (§10). Give it
        // button semantics and focusability; the app's own click handler does
        // the rest.
        if (b.tagName !== 'BUTTON' && !b.hasAttribute('data-aii-a11y')) {
          b.setAttribute('data-aii-a11y', '1');
          b.setAttribute('role', 'button');
          b.setAttribute('tabindex', '0');
          b.addEventListener('keydown', function (e) {
            if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') {
              e.preventDefault();
              this.click();
            }
          });
        }
      }
    };
    relabel();
    [300, 900, 2000].forEach(function (d) { setTimeout(relabel, d); });
    if ('MutationObserver' in window) {
      new MutationObserver(relabel).observe(root, { childList: true, subtree: true });
    }
  }

  /* ── Judge.me badge labels ──────────────────────────────────────────── */
  // The cached metafield badge renders "1 review" / "292 reviews"; the live
  // grid shows "(1)" / "(292)". The number and the word share one text node,
  // so this can't be done in CSS. Judge.me also lazy-renders, hence the
  // retries + observer.
  function cleanStars() {
    var nodes = document.querySelectorAll('.aii-stars .jdgm-prev-badge__text');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      var m = n.textContent.trim().match(/(\d+)/);
      if (!m) continue;
      var pretty = '(' + m[1] + ')';
      if (n.textContent !== pretty) n.textContent = pretty;
    }
  }
  if (window.jdgm && window.jdgm.customizeBadges) {
    try { window.jdgm.customizeBadges(); } catch (e) {}
  }
  cleanStars();
  [200, 600, 1500, 3000].forEach(function (d) { setTimeout(cleanStars, d); });
  if ('MutationObserver' in window) {
    var gridEl = document.querySelector('.aii-grid');
    if (gridEl) {
      new MutationObserver(cleanStars).observe(gridEl, {
        childList: true, subtree: true, characterData: true
      });
    }
  }

  /* ── boot ───────────────────────────────────────────────────────────── */
  if (phase === 'gate' && isUnlocked()) openUp();
  else seedFromCart();
})();
